<script lang="ts">
	import { Label, Select } from "flowbite-svelte-v1";
	import type { Page } from "#gen/pages/v2/page_pb.js";
	import P from "#lib/components/P.svelte";
	import { HORIZONTAL_ALIGNMENTS, IMAGE_BORDER_RADIUS, IMAGE_SIZES } from "#lib/components/flow/editor/appearance/constants.js";
	import type { JsonObject } from "#lib/protobuf-compat.js";
	import { setStringValue, setStructValue, stringValue, structValue } from "#lib/struct.js";
	import type { JsonValue } from "@bufbuild/protobuf";
	import type { Writable } from "svelte/store";

	interface Props {
		id: string;
		page: Writable<Page>;
		onChange: (value?: JsonValue) => void;
	}

	let { id, page, onChange }: Props = $props();

	const imageSize = $derived(stringValue(structValue($page.config, id), "imageSize") ?? IMAGE_SIZES[0].value);
	const borderRadius = $derived(stringValue(structValue($page.config, id), "borderRadius") ?? IMAGE_BORDER_RADIUS[0].value);
	const imageAlignment = $derived(stringValue(structValue($page.config, id), "imageAlignment") ?? "left");

	function getConfig(): JsonObject {
		let config = structValue($page.config, id);
		if (!config) {
			config = {} as JsonObject;
			setStructValue($page.config, id, config);
		}
		return config;
	}

	function handleChangeAppearance(e: Event, key: string) {
		const config = getConfig();
		const value = (e.target as HTMLSelectElement).value;
		if (value) {
			setStringValue(config, key, value);
		} else {
			delete config[key];
		}
		$page = $page;
		onChange?.();
	}
</script>

<div class="flex flex-col gap-5">
	<P class="text-sm font-bold text-black">Appearance</P>
	<div class="flex flex-row gap-2 border-l-[5px] border-l-gray-300 pl-6">
		<div class="flex basis-1/3 flex-col gap-1">
			<Label for="{id}-size-label" class="font-medium text-black">Size</Label>
			<Select classes={{ select: "truncate" }} items={IMAGE_SIZES} value={imageSize} aria-labelledby="{id}-size-label" onchange={e => handleChangeAppearance(e, "imageSize")} />
		</div>
		<div class="flex basis-1/3 flex-col gap-1">
			<Label for="{id}-border-radius-label" class="font-medium text-black">Border radius</Label>
			<Select classes={{ select: "truncate" }} items={IMAGE_BORDER_RADIUS} value={borderRadius} aria-labelledby="{id}-border-radius-label" onchange={e => handleChangeAppearance(e, "borderRadius")} />
		</div>
		<div class="flex basis-1/3 flex-col gap-1">
			<Label for="{id}-alignment-label" class="font-medium text-black">Alignment</Label>
			<Select classes={{ select: "truncate" }} items={HORIZONTAL_ALIGNMENTS} value={imageAlignment} aria-labelledby="{id}-alignment-label" onchange={e => handleChangeAppearance(e, "imageAlignment")} />
		</div>
	</div>
</div>
